import { useContext } from 'react';
import ShouldGetImagesFromPublicApiContext from '@/components/FileAttachments/ShouldGetImagesFromPublicApiContext';
import PortfolioItemCardThumbnailContext from './PortfolioItemCardThumbnailContext';
import useImageFileStatusRefreshing, {
  type ImageLocalStateUpdater,
} from '@/lib/files/useFileStatusRefreshing';

const useCardThumbnailFileStatusRefreshing = (): void => {
  const {
    portfolioItemSummary,
    setPortfolioItemSummary,
    portfolioItemApiEndpoint,
  } = useContext(PortfolioItemCardThumbnailContext);

  const shouldGetImagesFromPublicApi = useContext(
    ShouldGetImagesFromPublicApiContext,
  );

  useImageFileStatusRefreshing(
    `${portfolioItemApiEndpoint}/thumbnail/${portfolioItemSummary.thumbnail.id}/status${shouldGetImagesFromPublicApi ? '/public' : ''}`,
    portfolioItemSummary.thumbnail,
    (stateUpdater: ImageLocalStateUpdater): void => {
      setPortfolioItemSummary(portfolioItemSummary => {
        stateUpdater(portfolioItemSummary.thumbnail);
      });
    },
  );
};

export default useCardThumbnailFileStatusRefreshing;
